<!--
 * @Descripttion: 
 * @Author: liang
 * @Date: 2020-09-11 17:22:16
 * @LastEditors: liang
 * @LastEditTime: 2024-07-03 16:00:10
-->
<template>
  <div>
    <div class="main secondulli">
      <div class="nav">
        <div class="title">{{ leftNavName }}</div>
        <a
          :class="{ on: item.dictValue == tid }"
          v-for="(item, index) in navlist"
          @click="changetab(item.dictValue)"
          :key="index"
          >{{ item.dictName }}</a
        >
      </div>
      <div class="content">
        <!-- 循环navlist 对应显示内容 -->
        <div class="tabdiv">
          <div class="tablist">
            <!-- 内容 -->
            <div class="innercontent" v-if="tid < 2">
              <div class="article">
                <div class="titlename">
                  <h2>
                    {{ info ? info.title : "无" }}
                  </h2>
                </div>
                <div v-if="info" class="nr" v-html="info.content"></div>
                <div v-else class="nr">暂无</div>
              </div>
            </div>
            <!-- 列表 -->
            <ul v-if="tid == 2" class="yjlist">
              <li v-for="(item, index) in datalist" :key="index">
                <p>
                  {{ item.name }}
                </p>
                <span style="font-size:15px">{{
                  item.date ? item.date.split(" ")[0] : ""
                }}</span>
              </li>
            </ul>
            <div class="search" v-if="tid == 2">
              <el-input
                placeholder="请输入关键字"
                clearable
                v-model="keyword"
                size="small"
                class="input-with-select"
              >
                <el-button
                  slot="append"
                  size="small"
                  type="primary"
                  icon="el-icon-search"
                  @click="search"
                ></el-button>
              </el-input>
            </div>
            <!-- 内容end -->
          </div>
          <div class="pageno" v-if="tid == 2">
            <el-pagination
              background
              :current-page="pageno"
              @current-change="handleCurrentChange"
              layout="total, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      keyword: "",
      tid: "",
      tabid: "0",
      pageno: 1,
      navlist: [],
      tablist: [],
      info: {},
      bbtypelist: [],
      datalist: [],
      aindex: 0,
      total: 0,
      ptype: 0,
      leftNavName: ""
    };
  },
  watch: {
    $route: {
      handler() {
        this.tid = this.$route.query.tid;
        this.ptype = this.$route.query.ptype || 0;
        this.pageno = this.$route.query.pageno - 0 || 1;
        this.keyword = this.$route.query.keyword || "";
        this.tabid = this.$route.query.tabid;
        // 二级菜单时，获取companySummaryType
        var nav = JSON.parse(localStorage.getItem("nav"));

        this.leftNavName = nav.filter(item => {
          return item.parent.code === "websitegczx";
        })[0].parent.name;
        var navlist = nav.filter(item => {
          return item.parent.code === "websitegczx";
        })[0].child;
        this.navlist = navlist;
        if (this.$route.query.tid == 11) {
          this.getbbtype();
        }
        this.getinfo();
      },
      immediate: true
    }
  },
  methods: {
    search() {
      this.$router.push({
        path: "/hxwebsiteconsult/hxwebsiteconsultgc",
        query: {
          tid: this.tid,
          pageno: 1,
          ptype: this.ptype,
          keyword: this.keyword
        }
      });
    },
    getinfo() {
      if (this.tid == 2) {
        //招标业绩
        this.getzbyj();
      } else {
        this.$get(
          "/website/getWebsiteConsult?menuCode=websitegczx&businessType=" +
            this.tid
        ).then(res => {
          this.info = res.data;
        });
      }
    },
    // getgs() {
    //   this.$get(
    //     "/website/fbggPage?menuCode=wesiteNotice&titleType=" +
    //       this.tid +
    //       "&limit=10&page=" +
    //       this.pageno +
    //       "&title=" +
    //       this.keyword
    //   ).then(res => {
    //     this.datalist = res.data.list;
    //     this.total = res.data.total;
    //   });
    // },
    getzbyj() {
      this.$get("/website/webperformance/page", {
        // menuCode: "websitegczx",
        businessType: 2,
        limit: 10,
        page: this.pageno,
        name: this.keyword
      }).then(res => {
        this.datalist = res.data.list;
        this.total = res.data.total;
      });
    },
    getbbtype() {
      this.$get("/sys/dict/type/biddingBusinessType").then(res => {
        this.bbtypelist = res.data.list;
      });
    },
    handleCurrentChange(val) {
      this.$router.push({
        path: "/hxwebsiteconsult/hxwebsiteconsultgc",
        query: {
          tid: this.tid,
          pageno: val,
          ptype: this.ptype,
          keyword: this.keyword
        }
      });
    },
    changetab(index) {
      this.$router.push({
        path: "/hxwebsiteconsult/hxwebsiteconsultgc",
        query: { tid: index, pageno: 1 }
      });
    }
    // changetabdiv(index) {
    //   this.aindex = index;
    //   this.ptype = index;
    //   this.pageno = 1;
    //   this.getzbyj(index);
    // }
  }
};
</script>
<style scoped>
.pageno {
  padding-top: 20px;
  text-align: right;
}
.tablist {
  width: 100%;
  padding-top: 40px;
  overflow: hidden;
}
.tablist ul {
  width: 100%;
}
.tablist ul li {
  width: 100%;
  height: 60px;
  display: flex;
  /* cursor: pointer; */
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px dashed #ccc;
}
.tablist ul.yjlist {
  width: 100%;
  float: right;
}
.tablist ul.yjlist p {
  line-height: 20px;
  font-size: 15px;
}
.tablist li p {
  font-size: 15px;
  flex: 1;
  line-height: 20px;
}
.tablist li span {
  color: #666;
  width: 120px;
  text-align: right;
  font-size: 15px;
}
.tablist li:hover p,
.tablist li:hover span {
  color: #168eca;
}
.search {
  width: 300px;
  position: absolute;
  right: 0;
  top: 0;
}
.tabdiv {
  position: relative;
}
.tabdiv > ul {
  position: absolute;
  left: -20px;
  top: 7px;
  /* border-bottom: 1px solid rgb(104, 144, 206); */
}
.tabdiv .redsanjiao {
  position: absolute;
  left: -39px;
  top: 122px;
  font-size: 30px;
}
.tabdiv > ul li {
  padding: 0 15px;
  display: block;
  width: 170px;
  overflow: hidden;
  background: #fff;
  border-top: none;
  font-size: 14px;
}
#secondnav {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid rgb(138, 159, 197);
  box-sizing: border-box;
  height: 80px;
}
.secondnav {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
/* 下拉导航 */
div /deep/.el-menu-item {
  border-bottom: 1px solid #fff;
  text-align: center;
}
div /deep/.el-menu-item.is-active {
  background: #fff !important;
}
li /deep/.el-submenu__title,
li /deep/.el-submenu.is-active .el-submenu__title {
  border-bottom: 1px solid #fff !important;
  text-align: center;
}
li /deep/.el-menu--inline li {
  border-bottom: 1px dashed #fff;
  background: rgb(217, 221, 230) !important;
}
li /deep/.el-menu--inline li:last-child {
  border-bottom: 1px solid #fff;
}
ul /deep/.el-menu-item:hover {
  background: #fff !important;
  color: #9c1f21 !important;
  background: rgb(183, 197, 226) !important;
}
li /deep/.el-submenu__title:hover {
  background: rgb(183, 197, 226) !important;
}
/* 下拉导航 end*/
.secondnav .title {
  font-weight: bold;
  float: left;
  padding: 0 25px;
  line-height: 75px;
  display: inline-block;
  font-size: 16px;
  border-bottom: 5px solid rgb(30, 69, 141);
  box-sizing: border-box;
}
.secondnav .nav {
  float: right;
  height: 80px;
  display: flex;
  align-items: center;
}
.secondnav .nav a {
  display: inline-block;
  padding: 10px 15px;
  background: rgb(102, 119, 170);
  margin-left: 20px;
  font-size: 16px;
  color: #fff;
}
.secondnav .nav a.on,
.secondnav .nav a:hover {
  background: #be1314;
}
.secondnav .mbx {
  float: left;
  padding-top: 33px;
  padding-left: 50px;
}
/* .innercontent {
  padding-top: 20px;
} */

.article {
  background: #fff;
}
.titlename {
  padding: 30px 0;
  border-bottom: 1px dashed #ccc;
}
.nr {
  padding: 20px 60px;
  line-height: 42px;
}
.nr /deep/img {
  max-width: 100%;
}
.titlename h2 {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.titlename p {
  text-align: center;
  padding-top: 10px;
  font-size: 16px;
  color: #999;
}
.titlename p span {
  padding: 10px 0;
}
.content {
  min-height: 500px;
}
</style>
